<div class="school-subjects-filter-footer">
  <div class="school-subjects-filter-footer__reset" (click)="resetAll()">Alle löschen</div>
  <div class="school-subjects-filter-footer__apply" (click)="onClosed.emit(true);">{{233}} Berufe anzeigen</div>
</div>
